const ADDRESS_FIELD_LABELS = {
  postalCode: 'postcode',
  administrativeArea: 'state',
  locality: 'suburb',
  addressLine1: 'street address',
  countryCode: 'country',
};

const ADDRESS_TYPE_LABELS = {
  shippingAddress: 'shipping',
  billingAddress: 'billing',
};

function isAddressErrorKey(key) {
  return (
    key === 'shippingAddress' ||
    key.startsWith('shippingAddress.') ||
    key === 'billingAddress' ||
    key.startsWith('billingAddress.')
  );
}

function flattenErrorMessages(errors) {
  if (!errors || typeof errors !== 'object') {
    return [];
  }

  return Object.values(errors).flatMap((value) => {
    if (Array.isArray(value)) {
      return value.filter(Boolean);
    }

    return value ? [String(value)] : [];
  });
}

function formatAddressError(key) {
  const [addressType, field] = key.split('.');
  const addressLabel = ADDRESS_TYPE_LABELS[addressType] || 'saved';
  const fieldLabel =
    ADDRESS_FIELD_LABELS[field] || field?.replace(/([A-Z])/g, ' $1').trim();

  if (field === 'postalCode') {
    return `Your saved ${addressLabel} address is missing a postcode. Please update it in My Account before adding items to your cart.`;
  }

  if (fieldLabel) {
    return `Your saved ${addressLabel} address has an invalid ${fieldLabel}. Please update it in My Account.`;
  }

  return null;
}

export function hasCartErrors(data) {
  return Boolean(data?.errors && Object.keys(data.errors).length > 0);
}

export function hasAddressCartErrors(data) {
  const errors = data?.errors;
  if (!errors || typeof errors !== 'object') {
    return false;
  }

  return Object.keys(errors).some(isAddressErrorKey);
}

export function getCartErrorMessage(data, fallback = 'Unable to update cart.') {
  const errors = data?.errors;
  if (!errors || typeof errors !== 'object') {
    return data?.message || fallback;
  }

  const messages = [];

  for (const [key, value] of Object.entries(errors)) {
    if (isAddressErrorKey(key)) {
      const formatted = formatAddressError(key);
      if (formatted) {
        messages.push(formatted);
        continue;
      }
    }

    messages.push(...flattenErrorMessages({ [key]: value }));
  }

  const uniqueMessages = [...new Set(messages.filter(Boolean))];
  return uniqueMessages.join(' ') || data?.message || fallback;
}
